import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const KnowledgeGraphExtract = React.lazy(() => import("./KnowledgeGraphExtract"));

/**
 * Knowledge Graph — admin-only tool (like Module Sync). Permissions single-sourced
 * in the backend (knowledge-graph/permissions.ts). No navbar entry; reached from
 * /admin/knowledge-graph (linked from the Transcript Miner catalogue).
 */
const knowledgeGraphModuleConfig: ModuleConfig = {
  id: "knowledge-graph",
  name: "Knowledge Graph",
  description: "Extract a wiki-linked free-energy network from Transcript Miner transcripts via local AI.",
  version: "1.0.0",
  enabled: true,
  category: "tools",
  order: 99,
  icon: "🕸",
  routes: [
    { path: "/admin/knowledge-graph", component: KnowledgeGraphExtract, permissionLevel: "view", useLayout: true },
  ],
  navigation: [],
  permissions: { view: [], create: [], edit: [], delete: [] },
};

export default knowledgeGraphModuleConfig;
